<template>
  <div class="ts-settings-delegate">
    <of-page mode="list">
      <div slot="toolBar" class="search-btn" style="line-height:0;">
        <el-form ref="form" :inline="true" :model="dataForm">
          <el-form-item label="人员：">
            <employee-select
              style="width:220px"
              :multiple="false"
              placeholder="请选择人员"
              v-model="dataForm.EmployeeName"
            ></employee-select>
          </el-form-item>
          <el-form-item label="部门：">
            <department-select
              style="width:220px"
              :multiple="false"
              placeholder="请选择部门"
              v-model="dataForm.SecondmentDepartmentName"
            ></department-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-plus" size="small" @click="onAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="searchBar">
        <of-search @search="search" placeholder="输入员工号、姓名查询"></of-search>
      </div>
      <div>
        <el-table
          border
          highlight-current-row
          style="width: 100%"
          header-cell-class-name="header-row"
          :data="listData"
          :max-height="tebleMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column prop="EmployeeNo" width="150" label="员工号"></el-table-column>
          <el-table-column prop="RealName" width="150" label="员工姓名"></el-table-column>
          <el-table-column prop="FullDepartmentName" label="所属部门"></el-table-column>
          <el-table-column label="挂职部门" prop="SecondmentFullDepartmentName">
            <template slot-scope="scope">
              <span>{{scope.row.SecondmentFullDepartmentName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center" header-align="center">
            <template slot-scope="scope">
              <el-popover placement="top" v-model="scope.row.showDelete">
                <p>确定要删除吗？</p>
                <div>
                  <el-button
                    type="danger"
                    style="background:#F56C6C;color:#fff;border:none;"
                    size="mini"
                    @click="onDelete(scope.row)"
                  >确定</el-button>
                  <el-button type="text" @click="scope.row.showDelete=false" size="mini">取消</el-button>
                </div>
                <el-button type="text" slot="reference" size="mini">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <of-pagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></of-pagination>
        </div>
      </div>
    </of-page>
  </div>
</template>

<script>
import OfPage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import {
  querySecondment,
  deleteSecondment,
  saveSecondment
} from "@/modules/sys/api/employee.js";

import DepartmentSelect from "@/modules/sys/components/department_select.vue";
import EmployeeSelect from "@/modules/sys/components/employee_select.vue";
import { constants } from "crypto";

export default {
  name: "ts-settings-delegate",
  components: {
    OfPage,
    OfSearch,
    OfPagination,
    DepartmentSelect,
    EmployeeSelect
  },
  data() {
    return {
      listData: [],
      total: 0,
      currentPage: 1,
      pageSize: 15,
      sortOrder: "desc",
      searchFields: "Account,EmployeeNo,RealName",
      serarchFilter: {
        keywords: ""
      },
      isloading: false,
      dataForm: {},
      deleteVisible: false
      //   editFormRules: {
      //     EmployeeId: [
      //       { required: true, message: "请选择人员", trigger: "change" }
      //     ],
      //     SecondmentDepartmentId: [
      //       { required: true, message: "请选择部门", trigger: "change" }
      //     ]
      //   }
    };
  },
  filters: {
    statuFilter: function(value) {
      if (value === 20) return "已过期";
      else if (value === 1) return "已生效";
      else return "已失效";
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isloading = true;
      this.listData = [];
      querySecondment(
        this.currentPage,
        this.pageSize,
        this.sortOrder,
        this.searchFields,
        this.serarchFilter.keywords
      ).then(rep => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          rep.data.Data.rows.forEach(x => {
            x.showDelete = false;
            this.listData.push(x);
          });
        }
        this.isloading = false;
      });
    },
    formCallBack(val) {
      val && this.loadData();
    },
    search(keyword) {
      this.serarchFilter.keywords = keyword;
      this.currentPage = 1;
      this.loadData();
    },
    batchDel() {
      this.innerDel({ Id: this.batchId });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    onAdd() {
      if (
        !this.dataForm.EmployeeName ||
        this.dataForm.EmployeeName.length <= 0
      ) {
        this.$message.error("请选择人员");
        return;
      }
      if (
        !this.dataForm.SecondmentDepartmentName ||
        this.dataForm.SecondmentDepartmentName.length <= 0
      ) {
        this.$message.error("请选择部门");
        return;
      }
      let emp = this.dataForm.EmployeeName[0];
      let dept = this.dataForm.SecondmentDepartmentName[0];

      let obj = {
        EmployeeId: emp.Id,
        Account: emp.Account,
        EmployeeNo: emp.EmployeeNo,
        RealName: emp.RealName,
        MobileNo: emp.MobileNo,
        FullDepartmentName: emp.FullDepartmentName,
        SecondmentDepartmentId: dept.id,
        SecondmentDepartmentName: dept.text,
        SecondmentFullDepartmentId: dept.data ? dept.data.FullDepartmentId : "",
        SecondmentFullDepartmentName: dept.data
          ? dept.data.FullDepartmentName
          : ""
      };

      saveSecondment(obj).then(x => {
        this.$message.success("添加成功");
        this.dataForm = {};
        this.currentPage = 1;
        this.loadData();
      });
    },
    onDelete(item) {
      item.showDelete = false;
      deleteSecondment(item.Id).then(x => {
        if (x.data.Code !== 0) {
          this.$message.error(x.data.Message);
          return;
        }
        this.$message.success("删除成功");
        this.currentPage = 1;
        this.loadData();
      });
    },
    tebleMaxHeight() {
      var clientHeight = window.innerHeight
      var tableMaxHeight = 0
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 213
      }
      return tableMaxHeight
    }
  }
};
</script>

<style scoped>
.search-btn>>>.el-form-item{
  margin-bottom: 0;
}
</style>
